import BaseModel from "./base/baseModel";

export default class FracionamentoCancelamentoItemEmbalagemModel extends BaseModel {
    id?: number = null;
    fracionamentoCancelamentoId = 0;
    itemEmbalagemFracionamentoId?: number = null;
    quantidade?: number = null;
    unidadeMedidaId?: number = null;

    descricao: string = null;
    unidadeMedidaDescricao: string = null;
}
